import React, { Component } from 'react'
import DataWrapper from '../../principal/containers/DataWrapper'
import { inject, observer } from 'mobx-react'
import { Button, Col, Container, Row } from "reactstrap"
import VeicCdtaStore from '../stores/VeicCdtaStore'
import TabelaVeicCdta from '../components/TabelaVeicCdta'
import Footer from '../../comum/components/Footer'
import FooterContent from '../../comum/components/FooterContent'
import FooterOptions from '../../comum/components/FooterOptions'
import IconButton from '../../comum/components/IconButton'
import ModalAnexoCdta from '../components/ModalAnexoCdta'
import ModalAviso from '../../comum/components/ModalAviso'
import TabelaAnexosCdta from '../components/TabelaAnexosCdta'
import FiltroAnexosCdta from '../components/FiltroAnexosCdta'

@inject("store")
@DataWrapper
@observer
export class VeiculosCDTA extends Component {

    constructor(props) {
        super(props)

        this.controller = new VeicCdtaStore()

        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.renderModalAnexo = this.renderModalAnexo.bind(this)
        this.renderModalMensagem = this.renderModalMensagem.bind(this)
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Veículo Aguardando CDTA");
    }

    renderModalAnexo() {
        return this.controller.showModalAnexo ? <ModalAnexoCdta controller={this.controller} /> : null
    }

    renderModalMensagem() {
        return this.controller.mensagemVeic !== "" ? <ModalAviso onClickFechar={this.controller.fecharModalMensagem}><h2>{this.controller.mensagemVeic}</h2></ModalAviso> : null;
    }

    render() {
        return (
            <div>
                {this.renderModalAnexo()}
                {this.renderModalMensagem()}
                <Container className="tela-botoes-inclusao-topo" fluid>
                    <Row className="botoes-inclusao-topo">
                        <Col xs={12} sm={12} md={12} >
                            <Button onClick={ this.controller.toogleAnexos } className="btn-com-bordas-primary">
                                {
                                    this.controller.mostrarAnexos
                                    ? "Fechar Anexos"
                                    : "Mostrar Anexos"
                                }
                            </Button>
                        </Col>
                    </Row>
                    {this.controller.mostrarAnexos && <FiltroAnexosCdta controller={this.controller} />}
                    {
                        this.controller.mostrarAnexos
                        ? <TabelaAnexosCdta controller={this.controller} />
                        : <TabelaVeicCdta controller={ this.controller } />
                    }
                </Container>
                <Footer>
                    <FooterContent>
                    <div>
                            <b>{this.controller.itens.length}</b> 
                            {this.controller.itens.length === 1
                            ?" Veículo encontrado "
                            :" Veículos encontrados "
                            }
                            - <a className="btn-primary pl-0 pr-0" onClick={this.controller.listar}>Atualizar lista</a>
                        </div>
                    </FooterContent>
                </Footer>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/veiculoscdta/telas/VeiculosCDTA.js